/**
 * @generated SignedSource<<5ace6dbbd53179d66a43c9ae6dee388d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BalanceQuery$variables = {};
export type BalanceQuery$data = {
  readonly balance: {
    readonly " $fragmentSpreads": FragmentRefs<"Balance_balance">;
  } | null;
};
export type BalanceQuery = {
  variables: BalanceQuery$variables;
  response: BalanceQuery$data;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BalanceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Balance",
        "kind": "LinkedField",
        "name": "balance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Balance_balance"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "BalanceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Balance",
        "kind": "LinkedField",
        "name": "balance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MoneyAmount",
            "kind": "LinkedField",
            "name": "amount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formatted",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "81503f64698e73ad814038cc33f58c51",
    "id": null,
    "metadata": {},
    "name": "BalanceQuery",
    "operationKind": "query",
    "text": "query BalanceQuery {\n  balance {\n    ...Balance_balance\n    id\n  }\n}\n\nfragment Balance_balance on Balance {\n  id\n  amount {\n    formatted\n  }\n}\n"
  }
};

(node as any).hash = "4ffcaeebee38d0a015e775491a9c1113";

export default node;
